import React from 'react';
import { DateTime } from 'luxon';
import { getDaySuffix } from '@util/config';

import HandFreeWhiteIcon from '@images/owner/ic_search_hands_free_white.svg';
import ProfilePic from '@images/profilePic.png';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const OwnerBotShareCard = ({ bot, shareBotDriveHandler }) => {
  const date = new Date(bot?.expires_at);
  const formattedTime = date.toISOString();
  const expireTime = DateTime.fromISO(formattedTime);
  const dayWithSuffix = expireTime ? `${expireTime.day}${getDaySuffix(expireTime.day)}` : 'Invalid Date';
  const month = expireTime ? expireTime.toFormat('MMMM') : 'Invalid Date';
  const year = expireTime ? expireTime.year : 'Invalid Date';
  const time = expireTime ? expireTime.toFormat('hh:mm:ss a') : 'Invalid Date'; // Updated line to include AM/PM
  const formattedExpireTime = expireTime ? `${dayWithSuffix} ${month} ${year}, ${time}` : 'Invalid Date';
  const Bucket_url = process.env.NEXT_PUBLIC_DELIEVERY_CONTENT_URL;
  const ProfilePicture = bot?.sender_avatar_url ? `${Bucket_url}${bot?.sender_avatar_url}` : ProfilePic;

  return (
    <div className="max-w-xs bg-white rounded-xl overflow-hidden shadow-lg">
      <div className="w-full flex p-[16px] flex-col items-start gap-[16px]">
        <div className="w-full flex pb-[16px] items-end border-b-[1px] border-b-solid botder-b-[#DDD]">
          <div className="w-full flex items-start gap-[16px]">
            <img src={ProfilePicture} alt="profile-pic" className="w-[50px] h-[50px] rounded-[1000px]" />
            <div className='w-full flex flex-col items-start'>
              <p className="text-[#000] text-center text-[24px] not-italic font-semibold leading-[normal] tracking-[-0.96px]">{bot.bot.name}</p>
              <div className="flex flex-col gap-[2px]">
                <p className="text-[#FFB648] text-left text-[14px] not-italic font-medium leading-[20px] tracking-[-0.64px]">This Bot is shared by {bot.sender}</p>
                <p className='text-[#000] text-left text-[14px] not-italic font-medium leading-[20px] tracking-[-0.64px]'>Expire Time: {formattedExpireTime}</p>
              </div>
            </div>
          </div>
        </div>
        <div className='w-full flex justify-between'>
          <div className='flex items-start gap-[8px]'>
            <button
              className="flex pl-[8px] pr-[12px] py-[6px] items-center gap-[6px] rounded-[1000px] border-[1px] border-solid border-[#25BD66] bg-[#008735] disabled:opacity-50"
              onClick={() => shareBotDriveHandler(bot)}
              disabled={bot.bot.status === 'personal_ready' ? false : true}
            >
              <img
                src={HandFreeWhiteIcon}
                alt="hand-free-icon"
              />
              <p className='text-[#F3F3F3] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>
                Drive
              </p>
            </button>
						{/* <button
							className="flex pl-[8px] pr-[12px] py-[6px] items-center gap-[6px] rounded-[1000px] border-[1px] border-solid border-[#25BD66] bg-[#008735] text-[#F3F3F3] disabled:opacity-50"
							onClick={() => shareBotDriveHandler(bot, true)}
							disabled={!(bot.bot.status === 'personal_ready')}
						>
							<AutoAwesomeIcon fontSize="small" />
							<p className="text-[#F3F3F3] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]">
								Drive with AI
							</p>
						</button> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OwnerBotShareCard;
